import { Component, Input, OnInit ,ViewChild,ElementRef} from '@angular/core';
import { EmployeeListing } from '../../../../common/models/employee-listing.model';
import { InvoiceService } from '../../../../features/invoice/services/invoice.service';
import { WeeklyHistoryItem } from '../../models/weekly-history-item.model';
import { WeeklyHistoryWeek } from '../../models/weekly-history-week.model';

@Component({
  selector: 'app-garment-weekly-history-modal',
  templateUrl: 'garment-weekly-history-modal.component.html',
  styleUrls: ['garment-weekly-history-modal.component.scss']
})
export class GarmentWeeklyHistoryModalComponent implements OnInit {
@ViewChild('printSection') printSection!: ElementRef;
  @Input() employee: EmployeeListing;
categories: string[] = []; 
  weeklyHistoryItems: WeeklyHistoryItem[];
  weeklyHistory: WeeklyHistoryWeek[];
  today: Date = new Date();
loaded:boolean=false;
  constructor(
    private invoiceService: InvoiceService,
  ) { 

  }
  
  async ngOnInit(): Promise<void> {
    this.loaded=false;
    await this.invoiceService.getWeeklyHistory(this.employee.customerCode, this.employee.departmentCode, this.employee.employeeCode).then((response) => {
      this.weeklyHistoryItems = response;
    });
 
  const categorySet = new Set<string>();
  this.weeklyHistoryItems.forEach(item => categorySet.add(item.catName));
  this.categories = Array.from(categorySet);

  const historyMap: { [date: string]: any } = {};
  this.weeklyHistoryItems.forEach(item => {
  const week =  new Date(item.dateOfInvoice).toISOString(); 

    if (!historyMap[week]) {
      historyMap[week] = { week };
      this.categories.forEach(cat => historyMap[week][cat] = 0);
    }

    historyMap[week][item.catName] = item.washQty;
  });

  this.weeklyHistory = Object.values(historyMap);
   this.loaded=true;
  }

changePrinterView(divId): void {
   var printContents = document.getElementById(divId).outerHTML;
  const popupWin = window.open('', '_blank', 'width=800,height=600');

  if (popupWin) {
    popupWin.document.open();

    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
      .map((node) => node.outerHTML)
      .join('');

    popupWin.document.write(`
      <html>
        <head>
          <title>Weekly History</title>
          ${styles} 
          <style>
            ion-row, ion-col {
              display: block;
              padding: 4px 0;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);

    popupWin.document.close();
  }
}

}